import React, { useCallback, useState } from "react";
import { UserScreen } from "../../layouts/user-screen.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { RequestPasswordResetForm } from "./request-password-reset-form.tsx";
import { ResetEmailSentScreen } from "./reset-email-sent-screen.tsx";
import { Alert } from "../../components/alerts/alert.tsx";
import { TextLink } from "../../components/text-link.tsx";

export const RequestPasswordResetScreen: React.FC = () => {
  const [successful, setSuccessful] = useState<boolean>(false);
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(async (email: string) => {
    setLoading(true);
    const requestBody = {
      Email: email,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    };

    try {
      const response = await fetch("/users/new-reset-password", requestOptions);
      setSent(true);
      if (response.ok) {
        setSuccessful(true);
      } else {
        setErrorMessage(response.statusText);
      }
    } catch {
      setErrorMessage("Unable to reset password, please try again");
    } finally {
      setLoading(false);
    }

    setEmail(email);
  }, []);

  if (successful) {
    return <ResetEmailSentScreen onSubmit={onClick} email={email} />;
  } else {
    return (
      <UserScreen
        image={"/static/images/web-promo-pink-narrow.webp"}
        headerText={"Forgot your password?"}
        dismissible={false}
      >
        <div className="flex flex-col gap-4.5 md:gap-6 relative px-4.5 pb-5 pt-4.5 md:px-7.5 md:pb-7.5 md:pt-6">
          {sent && (
            <div className="mb-5">
              <Alert
                color="red"
                message={errorMessage}
                renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-triangle-exclamation" />}
                style="outlined"
                title="Error"
              />
            </div>
          )}
          <p className={`font-normal ${FontStyles[`body-l`]}`}>
            Enter below the email address you used to create your account. You’ll receive an email shortly with
            instructions on how to reset your password. Make sure to check your spam folder.
          </p>
          <RequestPasswordResetForm onSubmit={onClick} loading={loading} />
          <TextLink className="m-auto" href="/users/login">
            Back to Sign in
          </TextLink>
        </div>
      </UserScreen>
    );
  }
};
